import styles from "./styles.module.sass";
import { useEvent } from "effector-react/scope";
import { useRouter } from "next/router";
import { useStore } from "effector-react";
import SectionItem from "@features/Course/parts/course/Content/parts/SectionItem";
import { $course, setCurrentAsset } from "@features/Course/model/public";
import { LectureResponse } from "@services/api/lectures/typedef";

type SectionProps = {
	items: LectureResponse[];
};

const Section = ({ items }: SectionProps) => {
	const setCurrentContent = useEvent(setCurrentAsset);
	const course = useStore($course);

	const router = useRouter();

	const handleFreeClick = (item: LectureResponse) => {
		if (!course) {
			return;
		}
		setCurrentContent(item);
		router.push(`/course/${course.url}/watch`);
	};

	return (
		<ul className={styles.listingWrapper}>
			{items.map((item, index) => {
				return (
					<li className={styles.item} key={index}>
						<SectionItem item={item} handleFreeClick={handleFreeClick} />
					</li>
				);
			})}
		</ul>
	);
};

export default Section;
